import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("FiberPass ErrorBoundary:", error, info?.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="absolute inset-0 z-[2000] flex items-center justify-center bg-slate-950/95 p-6" data-testid="error-boundary">
          <div className="max-w-lg w-full rounded-xl border border-rose-600/50 bg-slate-900 p-5 text-slate-200 shadow-2xl">
            <div className="text-rose-300 font-semibold text-lg mb-2">Wystąpił błąd w widoku{this.props.label ? ` (${this.props.label})` : ""}</div>
            <p className="text-sm text-slate-400 mb-3">Ten fragment aplikacji się nie załadował. Spróbuj odświeżyć stronę. Jeśli problem się powtarza, prześlij poniższy komunikat.</p>
            <pre className="text-xs bg-slate-950 border border-slate-700 rounded p-2 overflow-auto max-h-40 text-rose-200 whitespace-pre-wrap">{String(this.state.error?.message || this.state.error)}</pre>
            <div className="flex gap-2 mt-3">
              <button onClick={() => this.setState({ error: null })} data-testid="error-retry" className="bg-cyan-600 hover:bg-cyan-500 text-white rounded px-3 py-1.5 text-sm">Spróbuj ponownie</button>
              <button onClick={() => window.location.reload()} data-testid="error-reload" className="bg-slate-700 hover:bg-slate-600 text-white rounded px-3 py-1.5 text-sm">Odśwież stronę</button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
